import axios from 'axios'

/**
 * Service for managing area data with the API
 * @namespace ClusterService
 */
const ClusterService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the area to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('admin/clusters', { params })
  },

  /**
   * Create a new area
   * @async
   * @param {Object} params - The area data to be created
   * @returns {Promise<Object>} The API response containing the created area
   */
  async post (params = {}) {
    return axios.post('admin/clusters', params)
  },

  /**
   * Update an existing area
   * @async
   * @param {Object} params - The area data to be updated
   * @param {string|number} params.id - The ID of the area to be updated
   * @returns {Promise<Object>} The API response containing the updated area
   */
  async put (params = { id: '' }) {
    return axios.put(`admin/clusters/${params.id}`, params)
  },

  /**
   * Delete an area by ID
   * @async
   * @param {Object} data - The data containing ID of area to delete
   * @param {string|number} data.id - The ID of the area to be deleted
   * @returns {Promise<Object>} The API response after deletion
   */
  async delete (data = { id: '' }) {
    return axios.delete(`admin/clusters/${data.id}`, { data })
  }
}

export default ClusterService
